import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { TextInput, PhoneInput, ToggleSwitch, NumericInput, PercentageInput } from "@/components/inputs";

/**
 * BorrowerInfoStep — Step 2: collects primary applicant details.
 */
export default function BorrowerInfoStep() {
  const { control, formState: { errors } } = useFormContext();
  const e = errors?.applicant;

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-5">
      <div className="col-span-4 sm:col-span-2">
        <Controller name="applicant.firstName" control={control} render={({ field }) => (
          <TextInput placeholder="First Name *" value={field.value} onChange={field.onChange} error={e?.firstName?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="applicant.lastName" control={control} render={({ field }) => (
          <TextInput placeholder="Last Name *" value={field.value} onChange={field.onChange} error={e?.lastName?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="applicant.email" control={control} render={({ field }) => (
          <TextInput placeholder="Email *" value={field.value} onChange={field.onChange} error={e?.email?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="applicant.phoneNumber" control={control} render={({ field }) => (
          <PhoneInput placeholder="Phone Number" value={field.value} onChange={field.onChange} error={e?.phoneNumber?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="applicant.mobileNumber" control={control} render={({ field }) => (
          <PhoneInput placeholder="Mobile Number" value={field.value} onChange={field.onChange} error={e?.mobileNumber?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="applicant.ficoScore" control={control} render={({ field }) => (
          <NumericInput placeholder="FICO Score *" value={field.value} onChange={field.onChange} min={300} max={850} format="n0" error={e?.ficoScore?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="applicant.liquidity" control={control} render={({ field }) => (
          <NumericInput placeholder="Liquidity (Cash) *" value={field.value} onChange={field.onChange} format="c0" currency="USD" min={0} error={e?.liquidity?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="applicant.netWorth" control={control} render={({ field }) => (
          <NumericInput placeholder="Net Worth" value={field.value} onChange={field.onChange} format="c0" currency="USD" error={e?.netWorth?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="applicant.ownershipPercentage" control={control} render={({ field }) => (
          <PercentageInput placeholder="Ownership %" value={field.value} onChange={field.onChange} error={e?.ownershipPercentage?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="applicant.hasBeenBankruptcy" control={control} render={({ field }) => (
          <ToggleSwitch label="Filed for Bankruptcy?" checked={field.value ?? false} onChange={field.onChange} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="applicant.isUsCitizen" control={control} render={({ field }) => (
          <ToggleSwitch label="US Citizen?" checked={field.value ?? true} onChange={field.onChange} />
        )} />
      </div>
    </div>
  );
}

